module.exports = __webpack_public_path__ + "static/media/giorgio-armani-black-code-big.0ff634af.png";